export default __webpack_public_path__ + "static/media/popularIcon.82df1ea2.svg";